import React, { Fragment, useCallback } from 'react';
import { injectIntl } from 'react-intl-next';

import TextField from '@atlaskit/textfield';
import { Field, ErrorMessage, HelperMessage } from '@atlaskit/form';

import { sharedi18n } from '../sharedi18n';

import { i18n } from './i18n';
import type { ContentStateTextFieldProps } from './types';

const ContentStateTextFieldComponent = ({
	onFocusTextField,
	showFormFooter,
	userOffline,
	intl: { formatMessage },
}: ContentStateTextFieldProps) => {
	const checkForTab = useCallback(
		(event: any) => {
			// if user didn't press tab, means they want to type on the textfield and not tab to next element
			if (event.key !== 'Tab') {
				onFocusTextField();
			}
		},
		[onFocusTextField],
	);

	const validateName = (value: string | undefined) => {
		if (!value) return 'REQUIRED'; // Name input is required
		return undefined;
	};

	return showFormFooter ? (
		<Field name="name" validate={validateName}>
			{({ fieldProps, error }: any) => (
				<Fragment>
					<TextField
						{...fieldProps}
						placeholder={formatMessage(i18n.addCustomStatus)}
						isCompact
						autoComplete="off"
						testId="name-input"
						maxLength={20}
						isDisabled={userOffline}
					/>
					{error === 'REQUIRED' && (
						<ErrorMessage>{formatMessage(sharedi18n.requiredErrorMessage)}</ErrorMessage>
					)}
					{!error && <HelperMessage>{formatMessage(i18n.maxLengthEditor)}</HelperMessage>}
				</Fragment>
			)}
		</Field>
	) : (
		// Dummy name input is rendered in place of actual name input when user is not creating page status
		// in order to clear validation errors and input value since the current atlaskit field API doesnt
		// provide such flexibility
		<Field name="dummy-name">
			{({ fieldProps }) => (
				<TextField
					{...fieldProps}
					onKeyDown={checkForTab}
					onMouseDown={onFocusTextField}
					isDisabled={userOffline}
					placeholder={formatMessage(i18n.addCustomStatus)}
					isCompact
					value=""
					testId="dummy-name-input"
				/>
			)}
		</Field>
	);
};

export const ContentStateTextField = injectIntl(ContentStateTextFieldComponent);
